import React from 'react';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { ThemeProvider } from '@mui/material';
import { NylasScheduling } from '@nylas/react';
import { theme } from 'theme';

import { SchedulingWrapper } from './Scheduling.styles';
import { getNylasCalendarConfig } from '../../helpers';

export const Scheduling = () => {
  const nylasConfig = getNylasCalendarConfig();

  return (
    <IntlProvider>
      <ThemeProvider theme={theme}>
        <SchedulingWrapper className={'mt-5'}>
          <NylasScheduling
            configurationId={nylasConfig?.configId}
            schedulerApiUrl={nylasConfig?.domain}
            enableUserFeedback={false}
          />
        </SchedulingWrapper>
      </ThemeProvider>
    </IntlProvider>
  );
};
